<template>
  <li class="news_item">
    <router-link
      :to="`/news/${newsId}`"
      class="clearfix"
    >
      <div class="date">
        {{ publishedDate || new Date() | moment("YYYY/MM/DD") }}
      </div>
      <div
        class="tag"
        :class="tagColor"
      >
        {{ tagText }}
      </div>
      <div
        v-show="isPinned"
        class="fixtop"
      >
        [置頂]
      </div>
      <div class="content">
        {{ headline }}
      </div>
    </router-link>
  </li>
</template>
<script>
export default {
  name: 'NewsIndexMeta',
  props: {
    newsId: {
      type: Number,
      required: true
    },
    headline: {
      type: String,
      required: true
    },
    publishedDate: {
      type: String,
      required: true
    },
    tagText: {
      type: String,
      required: true
    },
    tagColor: {
      type: String,
      required: true
    },
    isPinned: {
      type: Boolean,
      default: false
    }
  }
}
</script>
